export const colors = {
    pink: '#EE3A68',
    pinkie:'rgba(255, 99, 132, 0.5)',
    lightPink: '#FFF8F9',
    mainBlack: '#1E0108',
    gray: '#C9CBCF',
    blue: '#3BA0EB',
    white: '#ffffff',
    violet: 'rgba(161, 0, 255, 0.5)',
  };

  export const fontBase = "'Montserrat', sans-serif";